"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    cognitoUserPoolId: 'ap-southeast-2_vUVRlSMWa',
    cognitoUserPoolWebClientId: '1g1a80gfo3ovuq75c8fqjrg3ma',
    cognitoRegion: 'ap-southeast-2',
};
//# sourceMappingURL=AuthConfig.js.map